/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer.
 * - cart links: keep shoppers in context by opening the drawer.
 */

function openDrawer() {
  /** @type {HTMLElement & {open?: () => void} | null} */
  const drawer = document.querySelector('theme-drawer#cart-drawer');

  if (!drawer || typeof drawer.open !== 'function') return false;

  drawer.open();
  return true;
}

function bindCartLinks() {
  if (document.documentElement.dataset.ballegoCartLinksBound === 'true') return;

  document.documentElement.dataset.ballegoCartLinksBound = 'true';
  document.addEventListener(
    'click',
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

      const cartPath =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      const linkUrl = new URL(link.href, window.location.href);
      const cartUrl = new URL(cartPath, window.location.origin);

      if (linkUrl.origin !== window.location.origin || linkUrl.pathname !== cartUrl.pathname) return;

      event.preventDefault();
      if (!openDrawer()) window.location.href = linkUrl.href;
    },
    { capture: true }
  );
}

function init() {
  const actions = window.Shopify && window.Shopify.actions;
  bindCartLinks();
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') || document,
  });

  actions.openCart.configure({
    handler: function () {
      if (!openDrawer()) {
        window.location.href =
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify && window.Shopify.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
